import type { ComponentPropsWithRef } from 'react';

import { clsx } from '~/styles/utils';

import { textStyle } from './Text.css';

type Props = ComponentPropsWithRef<'p'>;

export const Text = ({ children, ...delegated }: Props) => {
  return (
    <p {...delegated} className={clsx(textStyle, delegated.className)}>
      {children}
    </p>
  );
};
